import request from '@/utils/request'

export function listShareNotices(params) {
  return request({
    url: '/api/custom/shareNotice/list',
    method: 'get',
    params,
    silent: true
  })
}

export function ackShareNotices(paperIds) {
  return request({
    url: '/api/custom/shareNotice/ack',
    method: 'post',
    data: { paperIds },
    silent: true
  })
}

export function ackAllShareNotices() {
  return request({
    url: '/api/custom/shareNotice/ack-all',
    method: 'post',
    silent: true
  })
}
